import { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { partnerQueryKeys } from "../../api/queryKeys";
import { fetchPartnerClients } from "../../api/endpoints/workspace";
import usePartnerQuery from "../../hooks/usePartnerQuery";

const SEARCH_DELAY_MS = 300;

/** Picks one of the partner's own clients, searching the server as they type. */
const ClientPicker = ({ value, onChange, error, disabled }) => {
  const [input, setInput] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setSearch(input.trim()), SEARCH_DELAY_MS);
    return () => clearTimeout(timer);
  }, [input]);

  const params = { page: 0, size: 20, ...(search ? { search } : {}) };
  const { data, isLoading } = usePartnerQuery(
    partnerQueryKeys.clients(params),
    () => fetchPartnerClients(params),
    { keepPreviousData: true }
  );

  return (
    <Autocomplete
      value={value}
      onChange={(_, next) => onChange(next)}
      inputValue={input}
      onInputChange={(_, next) => setInput(next)}
      options={data?.content || []}
      loading={isLoading}
      disabled={disabled}
      filterOptions={(options) => options}
      getOptionLabel={(client) => client?.name || ""}
      isOptionEqualToValue={(option, selected) => option.clientId === selected.clientId}
      renderOption={(props, client) => (
        <li {...props} key={client.clientId}>
          <div className="min-w-0">
            <div className="text-sm text-slate-900 truncate">{client.name}</div>
            <div className="text-xs text-slate-500 truncate">
              {client.email || client.phone || "No contact details"}
            </div>
          </div>
        </li>
      )}
      noOptionsText={search ? "No client matches that" : "No clients yet"}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Client"
          placeholder="Search by name, email or phone"
          size="small"
          margin="dense"
          error={Boolean(error)}
          helperText={error || undefined}
        />
      )}
    />
  );
};

export default ClientPicker;
